import { useTheme } from '../../../contexts/ThemeContext';
import { useDashboardUi } from '../../../config/dashboardUiTheme';
import { useTableUiTheme } from '../../../contexts/TableUiThemeContext';
import { cn } from '../../../lib/utils';

/** Re-render when Κλασικό / Νέο changes; shared dashboard tokens for all report pages. */
export function useReportUi() {
  const { theme } = useTheme();
  const dash = useDashboardUi(theme);
  const { themeId: tableUiThemeId } = useTableUiTheme();
  void tableUiThemeId;
  return { theme, dash, cn };
}

export function rateSemantic(rate) {
  if (rate >= 90) return 'success';
  if (rate >= 80) return 'warning';
  return 'danger';
}

export function insightSemantic(type) {
  const map = { success: 'success', warning: 'warning', danger: 'danger', info: 'info' };
  return map[type] || 'info';
}

export function trendTextClass(dash, trend) {
  if (trend === 'up') return dash.text('success');
  if (trend === 'down') return dash.text('danger');
  return dash.text('secondary');
}

const INSIGHT_BORDER = {
  success: 'border-l-emerald-500 dark:border-l-emerald-400',
  warning: 'border-l-amber-500 dark:border-l-amber-400',
  danger: 'border-l-rose-500 dark:border-l-rose-400',
  info: 'border-l-sky-500 dark:border-l-sky-400',
};

export function insightPanelClass(dash, type) {
  const key = insightSemantic(type);
  return cn(dash.listItem(), 'border-l-4', INSIGHT_BORDER[key] || INSIGHT_BORDER.info);
}

export function rateDisplayClasses(dash, rate) {
  const key = rateSemantic(rate);
  return { text: dash.text(key), bg: dash.iconBg(key) };
}

/** Map status / criticality / site labels to dashboard semantic keys for bars & badges. */
export function breakdownSemantic(label) {
  const s = String(label || '').toLowerCase();
  if (s.includes('critical') || s.includes('urgent') || s.includes('high')) return 'danger';
  if (s.includes('medium') || s.includes('open') || s.includes('progress') || s.includes('pending')) {
    return 'warning';
  }
  if (s.includes('low')) return 'info';
  if (s.includes('closed') || s.includes('complete') || s.includes('resolved')) return 'success';
  if (s.includes('cancel')) return 'secondary';
  return 'primary';
}

export function reportCardShell(dash, cn) {
  // Avoid overflow-hidden so native year <select> dropdowns are not clipped.
  return cn(dash.widgetShell(), 'p-0 shadow-sm');
}
